import { loadable } from '../../common/utils/lazyLoading';
import structure from './structures/menu';
const TranslationPage = loadable(() => import('./TranslationPage'));
export default {
    id: 'translation',
    title: 'Translation',
    icon: 'earth',
    route: 'translation',
    defaultRoute: 'translation/translation',
    hasDynamicDefaultRoute: true,
    group: 'administration',
    component: TranslationPage,
    panelExtensions: [],
    structure,
};
